import { GetterTree } from 'vuex'
import { AuditsState, Audit } from '@/store/modules/audits/auditsTypes'
import { RootState } from '@/store/types/storeGlobalTypes'

export const getters: GetterTree<AuditsState, RootState> = {
  getAudits(state): Audit[] | null {
    return state.audits
  }
}
